import { render, staticRenderFns } from "./inputGuide.vue?vue&type=template&id=28d98806&"
import script from "./inputGuide.vue?vue&type=script&lang=js&"
export * from "./inputGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports